/* ============================================================
   Blur Menu — behaviour (cached asset)
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MAX = 990;

  function isMobile() {
    return window.innerWidth < MOBILE_MAX;
  }

  function isOpen() {
    return document.body.classList.contains('blur-menu-open');
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* ------------------------------------------------------------
     Live instances + document-level listeners.

     These listeners used to be registered inside init(), once per
     initialised section. That looked safe because init() is guarded by
     section.dataset.bmReady — but the Theme Editor replaces the section
     with a BRAND NEW DOM node on every setting change, so the guard never
     matched and each re-render added another keydown handler, another
     resize handler and another nested shopify:section:load handler, none
     of which were ever removed. A customising session accumulated them
     linearly: Escape eventually fired N times per press.

     They now live at module scope, registered exactly once, and dispatch
     to whichever instance is currently mounted. Same teardown pattern as
     assets/mobile-toolbar.js, which already got this right.
     ------------------------------------------------------------ */
  var instances = [];
  var globalBound = false;

  function currentInstance() {
    for (var i = 0; i < instances.length; i++) {
      if (document.body.contains(instances[i].overlay)) return instances[i];
    }
    return null;
  }

  function onGlobalKeydown(e) {
    if (!isOpen()) return;
    var inst = currentInstance();
    if (!inst) return;
    if (e.key === 'Escape') {
      inst.close();
      return;
    }
    inst.trapFocus(e);
  }

  function onGlobalResize() {
    if (isMobile()) return;
    for (var i = 0; i < instances.length; i++) instances[i].close();
  }

  function bindGlobal() {
    if (globalBound) return;
    globalBound = true;
    document.addEventListener('keydown', onGlobalKeydown);
    window.addEventListener('resize', onGlobalResize, { passive: true });
  }

  /* Drop instances whose section has left the DOM, and take their portaled
     overlay with them. Without this the overlay - which init() moves into
     <body> so position:fixed resolves against the viewport - outlives every
     Theme Editor re-render. */
  function cleanupDetached() {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!document.contains(instances[i].section)) {
        try {
          instances[i].dispose();
        } catch (err) {
          /* one broken teardown must not strand the rest */
        }
        instances.splice(i, 1);
      }
    }
  }

  function init(section) {
    if (!section || section.dataset.bmReady === 'true') return;

    var overlay = section.querySelector('[data-blur-menu-overlay]');
    var panel = section.querySelector('[data-blur-menu-panel]');
    if (!overlay || !panel) return;

    section.dataset.bmReady = 'true';

    /* ------------------------------------------------------------
       بورتال: الـ overlay بينتقل يبقى آخر عنصر جوه <body>.
       ده بيضمن إن الـ position: fixed بتاعه يفضل نسبي للـ viewport
       دايمًا — حتى لو هيدر الثيم (أو أي عنصر أب تاني) عنده
       transform/filter/perspective/will-change، اللي بيعمل
       containing block جديد لأي عنصر fixed جواه. ده بالظبط سبب إن
       البانل كان بيغطي جزء من الصفحة بس، وإن سكرول الصفحة كان
       شغال من تحته وهو مفتوح.
       الفارياِبلز والستايلز المتعلّقة بالـ overlay/panel معرّفة في
       اللِكويد على [data-bm-id]، مش هي وراثة من الـ section، عشان
       تفضل شغالة صح بعد النقل.
       ------------------------------------------------------------ */
    var bmId = overlay.getAttribute('data-bm-id') || section.id;
    if (bmId) {
      var stale = document.body.querySelectorAll(
        '.blur-menu-overlay[data-bm-id="' + bmId + '"]'
      );
      for (var s = 0; s < stale.length; s++) {
        if (stale[s] !== overlay && stale[s].parentNode === document.body) {
          stale[s].parentNode.removeChild(stale[s]);
        }
      }
    }
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    var closeBtn = overlay.querySelector('[data-blur-menu-close]');
    var rootScreen = overlay.querySelector('[data-blur-menu-screen="root"]');
    var headerBack = overlay.querySelector('[data-blur-menu-back]');
    var labelText = overlay.querySelector('[data-blur-menu-label-text]');
    var labels = {
      menu: section.dataset.labelMenu || 'Menu',
      back: section.dataset.labelBack || 'Back'
    };
    var speedOut = parseInt(section.dataset.speedOut, 10) || 300;
    var currentScreen = 'root';
    var timer = null;
    var pressedOutside = false;
    var savedScrollY = 0;
    var lastFocused = null;

    /* ------------------------------------------------------------
       قفل السكرول: overflow:hidden على الـ body لوحده مش كافي —
       على سفاري iOS بالذات بيسيب المستخدم يسحب/يسكرول الصفحة اللي
       ورا البانل. فبنثبّت الـ body نفسه بـ position:fixed ونعوّض
       بإزاحة top بمكان السكرول الحالي، وبنرجّعه بالظبط لما نقفل.
       ------------------------------------------------------------ */
    function lockScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    /* ------------------------------------------------------------
       إظهار العناصر: اللي ظاهر في البانل بياخد stagger عادي،
       واللي تحت بيستنى لحد ما يوصل للشاشة (IntersectionObserver)
       ------------------------------------------------------------ */
    var observer = null;

    function clearReveal() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      var items = overlay.querySelectorAll('.bm-reveal');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-in', 'is-late');
        items[i].style.removeProperty('--bm-i');
      }
    }

    function revealScreen(screen) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      var items = [].slice.call(screen.querySelectorAll('.bm-reveal'));
      var footer = overlay.querySelector('.blur-menu-footer .bm-reveal');
      if (footer) items.push(footer);
      if (!items.length) return;

      var limit = panel.clientHeight || window.innerHeight;
      var visible = [];
      var later = [];

      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetTop < limit) visible.push(items[i]);
        else later.push(items[i]);
      }

      for (var v = 0; v < visible.length; v++) {
        visible[v].style.setProperty('--bm-i', v);
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          for (var v = 0; v < visible.length; v++) visible[v].classList.add('is-in');
        });
      });

      if (!later.length || !('IntersectionObserver' in window)) {
        for (var l = 0; l < later.length; l++) {
          later[l].style.setProperty('--bm-i', 0);
          later[l].classList.add('is-late', 'is-in');
        }
        return;
      }

      var batch = 0;
      var batchTime = 0;

      observer = new IntersectionObserver(
        function (entries) {
          var now = Date.now();
          if (now - batchTime > 260) batch = 0;
          batchTime = now;

          for (var e = 0; e < entries.length; e++) {
            if (!entries[e].isIntersecting) continue;
            var el = entries[e].target;
            el.style.setProperty('--bm-i', batch++);
            el.classList.add('is-late', 'is-in');
            observer.unobserve(el);
          }
        },
        { root: panel, threshold: 0.15 }
      );

      for (var j = 0; j < later.length; j++) observer.observe(later[j]);
    }

    function trigger() {
      return document.querySelector('[data-blur-menu-trigger]');
    }

    /* ---------- focus trap بسيط جوه البانل وهو مفتوح ---------- */
    function focusableItems() {
      var nodes = overlay.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      return [].slice.call(nodes).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var items = focusableItems();
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (!isMobile() || isOpen()) return;

      window.clearTimeout(timer);
      lastFocused = document.activeElement;
      lockScroll();

      overlay.removeAttribute('hidden');
      overlay.setAttribute('aria-hidden', 'false');
      if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');

      var btn = trigger();
      if (btn) btn.setAttribute('aria-expanded', 'true');

      panel.scrollTop = 0;

      /* double rAF عشان الترانزشن يشتغل بعد ما العنصر يترسم */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          document.body.classList.add('blur-menu-open');
          if (rootScreen) revealScreen(rootScreen);
          if (closeBtn) closeBtn.focus();
          else panel.focus();
        });
      });
    }

    function close() {
      if (!isOpen()) return;

      document.body.classList.remove('blur-menu-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (closeBtn) closeBtn.setAttribute('aria-expanded', 'false');

      var btn = trigger();
      if (btn) btn.setAttribute('aria-expanded', 'false');

      unlockScroll();

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      } else if (btn) {
        btn.focus();
      }
      lastFocused = null;

      window.clearTimeout(timer);
      var delay = prefersReducedMotion() ? 0 : speedOut + 60;
      timer = window.setTimeout(function () {
        if (!isOpen()) {
          overlay.setAttribute('hidden', '');
          clearReveal();
          reset();
        }
      }, delay);
    }

    function toggle() {
      if (isOpen()) close();
      else open();
    }

    /* ---------- شاشات ---------- */
    function setHeader(id) {
      if (!headerBack) return;
      headerBack.classList.toggle('is-back', id !== 'root');
      if (labelText) labelText.textContent = id === 'root' ? labels.menu : labels.back;
    }

    function go(id) {
      var target =
        id === 'root'
          ? rootScreen
          : overlay.querySelector('.blur-menu-screen[data-blur-menu-screen="' + id + '"]');

      if (!target || id === currentScreen) return;

      var screens = overlay.querySelectorAll('.blur-menu-screen');
      for (var i = 0; i < screens.length; i++) {
        if (screens[i] !== target) {
          screens[i].classList.remove('is-active');
          screens[i].setAttribute('hidden', '');
        }
      }

      target.removeAttribute('hidden');
      target.classList.remove('is-active');
      panel.scrollTop = 0;

      var previous = overlay.querySelectorAll('.bm-reveal.is-in');
      for (var p = 0; p < previous.length; p++) {
        previous[p].classList.remove('is-in', 'is-late');
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.classList.add('is-active');
          revealScreen(target);
        });
      });

      currentScreen = id;
      setHeader(id);
    }

    function reset() {
      var screens = overlay.querySelectorAll('.blur-menu-screen');
      for (var i = 0; i < screens.length; i++) {
        var isRoot = screens[i] === rootScreen;
        screens[i].classList.toggle('is-active', isRoot);
        if (isRoot) screens[i].removeAttribute('hidden');
        else screens[i].setAttribute('hidden', '');
      }
      currentScreen = 'root';
      setHeader('root');
    }

    /* ---------- أحداث ---------- */
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* قفل بالدوس في أي مكان بره البانل.
       بنتأكد إن الدوسة بدأت وخلصت بره، عشان السحب من جوه ميقفلش. */
    overlay.addEventListener('pointerdown', function (e) {
      pressedOutside = !panel.contains(e.target);
    });

    overlay.addEventListener('pointerup', function (e) {
      if (pressedOutside && !panel.contains(e.target)) close();
      pressedOutside = false;
    });

    /* keydown is handled at module scope (onGlobalKeydown) and routed back
       to this instance via the registry at the end of init(). */

    /* ملحوظة: الحدث ده كان متعلّق على section، لكن دلوقتي إن الـ
       overlay بينتقل يبقى جوه <body>، لازم يتعلّق على الـ overlay
       نفسه عشان يفضل بيسمع كل الكليكات اللي جواه (delegation
       بيعتمد على إن العنصر يكون أب فعلي في الـ DOM). */
    overlay.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-blur-menu-open]');
      if (opener) {
        e.preventDefault();
        go(opener.getAttribute('data-blur-menu-open'));
        return;
      }

      if (headerBack && e.target.closest('[data-blur-menu-back]')) {
        if (currentScreen !== 'root') go('root');
        return;
      }

      if (e.target.closest('a')) close();
    });

    /* resize is handled at module scope (onGlobalResize). */

    /* ---------- ربط أيقونة الهيدر ---------- */
    function bind() {
      var btn = trigger();
      if (!btn || btn.dataset.blurMenuBound === 'true') return;
      btn.dataset.blurMenuBound = 'true';

      btn.addEventListener(
        'click',
        function (e) {
          if (!isMobile()) return;
          e.preventDefault();
          e.stopPropagation();
          toggle();
        },
        true
      );
    }

    bind();

    /* Register with the module-scope dispatcher. `bind` is exposed so that a
       header re-render (which replaces the trigger button) can be re-bound
       from initAll rather than from a nested section:load listener. */
    instances.push({
      section: section,
      overlay: overlay,
      close: close,
      trapFocus: trapFocus,
      bind: bind,
      dispose: function () {
        window.clearTimeout(timer);
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        if (overlay && overlay.parentNode === document.body) {
          document.body.removeChild(overlay);
        }
        /* If this instance was mid-open when its section was removed, the
           scroll lock would otherwise stay applied to <body> forever. */
        if (isOpen()) {
          document.body.classList.remove('blur-menu-open');
          unlockScroll();
        }
      }
    });

    bindGlobal();
  }

  function initAll() {
    cleanupDetached();
    var sections = document.querySelectorAll('[data-blur-menu-section]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
    /* The header is a separate section; when IT re-renders the trigger button
       is replaced and needs re-binding even though no blur-menu section
       changed. Cheap and idempotent - bind() no-ops on an already-bound
       button. */
    for (var j = 0; j < instances.length; j++) instances[j].bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', cleanupDetached);
})();